











































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ISensorDevice, IIndicator } from '@/model/meta';
import { v4 as uuidv4 } from 'uuid';

import {
    required,
    minLength,
    maxLength,
    decimal,
    between
} from 'vuelidate/lib/validators';

import BaseTable from '@/components/Table/BaseTable.vue';
import BaseModalForm from '@/components/Form/BaseModalForm.vue';

export default Vue.extend({
    name: 'Devices',
    metaInfo: {
        title: 'Устройства',
    },
    components: {
        BaseTable,
        BaseModalForm,
    },
    methods: {
        ...mapActions('administration', {
            loadData: 'loadDevicesGrid',
            loadSubData: 'loadIndicatorsForDevice',
            loadSubDataGrid: 'loadIndicatorsSubGrid',
            createItem: 'createDevice',
            deleteItem: 'deleteDevice',
            updateItem: 'updateDevice',
            resetForm: 'resetForm'
        }),
        editModalShow(selectObj: ISensorDevice): void {
            this.editMode = 'edit';
            this.formShow = true;
            this.selected = selectObj;
        },
        newModalShow(): void {
            this.editMode = 'new';
            this.formShow = true;
        },
        deleteModalShow(selectObj: ISensorDevice): void {
            this.selected = selectObj;
            this.deleteShow = true;
        },
        submitForm(editObj: ISensorDevice): void {
            if (this.editMode === 'new') {
                this.createItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            } else {
                this.updateItem(editObj).then((result: boolean) => {
                    if (result === true) this.closeModalForm();
                });
            }
        },
        submitDeleteForm(editObj: ISensorDevice): void {
            this.deleteItem(editObj).then((result: boolean) => {
                if (result === true) this.closeModalForm();
            });
        },
        closeModalForm(): void {
            this.resetForm();
            this.formShow = false;
            this.deleteShow = false;
        },
        loadSubDataAction(loadforObj: ISensorDevice): void {
            this.loadSubData(loadforObj);
        },
    },
    computed: {
        ...mapGetters('administration', {
            allData: 'getDevicesGrid',
            subDataSet: 'getChooseIndicatorData',
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
        }),
        selectedName(): string {
            return this.selected === undefined ? '' : this.selected.name;
        },
        deleteMessage(): string {
            return 'Удалить выбранное устройство(' + this.selectedName + ')?';
        },
        formSettings(): Array<any> {
            return [
                {
                    name: 'code',
                    idPrefix: 'code-name',
                    labelText: 'Код',
                    inputType: 'input',
                    placeholder: 'Введите код устройства',
                    errorText:
                        'Ошибка. Обязательный параметр. Максимум 50 символов.',
                    validations: {
                        required,
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'password',
                    idPrefix: 'password-name',
                    labelText: 'Пароль',
                    inputType: 'input',
                    additionalType: 'password',
                    placeholder: 'Введите пароль устройства',
                    errorText: 'Ошибка. Минимум 5 символов.',
                    validations: {
                        maxLength: minLength(5),
                    },
                },
                {
                    name: 'name',
                    idPrefix: 'name-name',
                    labelText: 'Наименование',
                    inputType: 'input',
                    placeholder: 'Введите наименование устройства',
                    errorText:
                        'Ошибка. Обязательный параметр. Максимум 50 символов.',
                    validations: {
                        required,
                        maxLength: maxLength(50),
                    },
                },
                {
                    name: 'description',
                    idPrefix: 'description-name',
                    labelText: 'Описание',
                    inputType: 'textarea',
                    textareaRows: 6,
                    placeholder: 'Введите описание устройства',
                    errorText: 'Ошибка. Максимальная длинна 500 символов.',
                    validations: {
                        maxLength: maxLength(500),
                    },
                },
                {
                    name: 'isActive',
                    idPrefix: 'is-active',
                    labelText: 'Активность',
                    inputType: 'checkbox',
                    checkedValue: true,
                    uncheckedValue: false,
                    validations: {
                        required,
                    },
                },
                {
                    name: 'latitude',
                    idPrefix: 'latitude-name',
                    labelText: 'Широта',
                    inputType: 'input',
                    placeholder: 'Введите широту устройства',
                    errorText: 'Ошибка. Введите число от 0 до 90',
                    validations: {
                        decimal,
                        between: between(0, 90),
                    },
                },
                {
                    name: 'longitude',
                    idPrefix: 'longitude-name',
                    labelText: 'Долгота',
                    inputType: 'input',
                    placeholder: 'Введите долготу устройства',
                    errorText: 'Ошибка. Введите число от 0 до 180',
                    validations: {
                        decimal,
                        between: between(0, 180),
                    },
                },
                {
                    name: 'locality',
                    idPrefix: 'locality-name',
                    labelText: 'Ближайший город',
                    inputType: 'input',
                    placeholder: 'Введите ближайший город',
                    errorText: 'Ошибка. Максимальная длинна 500 символов.',
                    validations: {
                        maxLength: maxLength(500),
                    },
                },
                {
                    name: 'availableIndicators',
                    idPrefix: 'availableIndicators-name',
                    labelText: 'Доступные показатели',
                    inputType: 'grid',
                    primaryKey: 'indicatorId',
                    dataSet: this.subDataSet,
                    fields: this.detailFields,
                    validations: {},
                },
            ];
        }
    },
    mounted() {
        this.loadData();
        this.loadSubDataGrid();
    },
    data() {
        return {
            fields: [
                { key: 'code', label: 'Код', sortable: true },
                { key: 'name', label: 'Наименование', sortable: true },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'isActive', label: 'Активность', sortable: true },
                { key: 'latitude', label: 'Широта', sortable: true },
                { key: 'longitude', label: 'Долгота', sortable: true },
                { key: 'locality', label: 'Ближайший город', sortable: true },
            ],
            detailArrayName: 'availableIndicators',
            detailFields: [
                { key: 'code', label: 'Код', sortable: true },
                { key: 'name', label: 'Наименование', sortable: true },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'isActive', label: 'Активность', sortable: true },
            ],
            selected: undefined as undefined | ISensorDevice,
            formShow: false,
            deleteShow: false,
            editMode: 'new' as 'new' | 'edit',
            emptyObject: {
                sensorDeviceId: uuidv4(),
                code: undefined as string | undefined,
                password: undefined as string | undefined,
                name: undefined as string | undefined,
                description: undefined as string | undefined,
                isActive: false as boolean,
                latitude: 0.0 as number | undefined,
                longitude: 0.0 as number | undefined,
                locality: undefined as string | undefined,
                availableIndicators: [] as Array<IIndicator>,
            },
        };
    }
});
